import { Tabs } from '@approvalmax/ui/src/components';
import { memo, useMemo } from 'react';
import { useParams } from 'react-router-dom';

import { useBoardNavItems } from '../../hooks/useBoardNavItems';
import { homeTab } from './Navigation.constants';
import { Loading } from './Navigation.loading';
import { Content, Root } from './Navigation.styles';

export const Navigation = memo(() => {
    const { boardId } = useParams<{ boardId?: string }>();
    const activeBoardId = boardId || homeTab.value;

    const { items: boardNavItems, isInitialLoading } = useBoardNavItems();
    const items = useMemo(
        () => [homeTab, ...boardNavItems.map(({ postCount, ...currentItem }) => currentItem)],
        [boardNavItems]
    );

    if (!boardNavItems.length) return null;

    return (
        <Root>
            <Content>
                {isInitialLoading ? (
                    <Loading />
                ) : (
                    <Tabs value={activeBoardId} items={items} bordered={false} overflowX='initial' />
                )}
            </Content>
        </Root>
    );
});

Navigation.displayName = 'Navigation';
